export default __webpack_public_path__ + "static/media/thumbnail2.8bf642b6.jpg";